"use strict";

exports.__esModule = true;
exports.GridElement = void 0;
var _uiSwitch = require("../../Theme/UiDesign/uiSwitch");
var _GridElement = require("./GridElement.legacy");
var _GridElement2 = require("./GridElement.modern");
// Flag-gated UI: `GridElement.legacy` is the component as it is on master,
// `GridElement.modern` the ui-charts-update rewrite. The nearest UiDesignProvider
// (ENABLE_MODERN_UI + the screen's flag) decides which one renders.
var GridElement = exports.GridElement = (0, _uiSwitch.uiSwitch)(_GridElement.GridElement, _GridElement2.GridElement, "GridElement");